import React from "react";
import Heading from "../../components/Heading";
import "../DRS/style.scss";
import DRSList from "../DRS/DRSList";

const OpenDRS = () => {
  return (
    <div className="p-1">
      <Heading title="Open DRS" navigateTo="/dashboard" />
      <div className="global-card-tab-container">
        <DRSList hideCreateSection={true} defaultStatus="OPEN" />
      </div>
    </div>
  );
};

export default OpenDRS;
